import styled, { css } from 'styled-components';

export const Container = styled.aside`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 320px;
  max-width: 350px;
  border-left: 2px solid var(--color-gray-900);
  position: relative;
  height: calc(100dvh - 64px);

  h2 {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-navy-blue);
  }

  .group {
    display: flex;
    flex-direction: column;
  }

  .g1 {
    flex: 1;
    overflow: hidden;
  }

  .client {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 20px 20px 0px;

    p {
      font-size: 14px;
      color: var(--color-alba-grandeza);
    }

    label {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: var(--color-navy-blue);
    }

    .header {
      display: flex;
      justify-content: flex-start;
      gap: 10px;
    }

    .client__search {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: flex-start;
      gap: 10px;

      button {
        width: 38px;
        height: 38px;
        padding: 0px;
      }
    }
  }

  .cart {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    padding-top: 15px;

    h2 {
      margin-left: 20px;
      margin-bottom: 15px;
    }

    > div {
      max-height: 100%;
      height: 100%;
      overflow: auto;
      border-top: 2px solid var(--color-gray-900);

      scrollbar-width: thin;
      scrollbar-color: black transparent;

      &::-webkit-scrollbar {
        width: 3px;
        height: 3px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        padding: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #a1a1a1;
      }

      > p {
        user-select: none;
        font-size: 12px;
        line-height: 20px;
        white-space: nowrap;
        color: var(--color-gray-800);
        text-align: center;
      }
    }

    .loading {
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;

      span {
        border-color: var(--color-blue) var(--color-blue) var(--color-blue)
          transparent !important;
      }
    }
  }

  .address {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .delivery__type {
      border-top: 2px solid var(--color-gray-900);
      display: flex;
      flex-direction: column;
      padding: 15px;
      gap: 15px;

      .types {
        display: flex;
        gap: 5px;

        > div {
          flex: 1;
          justify-content: center;
        }
      }
    }

    .search__address {
      border-top: 2px solid var(--color-gray-900);
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 15px;

      label {
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: var(--color-navy-blue);
      }

      > div {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 10px;
        align-items: flex-start;

        > p {
          font-size: 14px;
          color: var(--color-alba-grandeza);
        }

        button {
          width: 38px;
          height: 38px;
          padding: 0px;
        }
      }
    }
  }

  .prices {
    border-top: 2px solid var(--color-gray-900);
    display: flex;
    flex-direction: column;
    padding: 15px;
    gap: 10px;

    div {
      display: flex;
      width: 100%;
      justify-content: space-between;
      font-size: 14px;
    }

    strong {
      font-weight: 600;
    }
  }

  .conclusion {
    border-top: 2px solid var(--color-gray-900);
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    width: 100%;

    button {
      font-size: 15px;
      padding: 0px;
      width: 44px;
      height: 44px;
    }

    button:first-child {
      flex: 1;
    }

    button:last-child {
      background-color: var(--color-red);
    }
  }

  span.loading {
    border-color: var(--color-blue) var(--color-blue) var(--color-blue)
      transparent !important;
  }

  .prev {
    position: absolute;
    top: 4px;
    right: 4px;
    background: none;
    border: none;

    svg {
      font-size: 36px;
      color: var(--color-red);
    }
  }

  @media (max-height: 649px) {
    .g1 {
      overflow-y: auto;
    }

    .cart {
      overflow: initial;
    }
  }
`;

export const ContainerItemSelectable = styled.div<{
  seleted?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  height: fit-content;
  transition: all 0.2s ease-in-out;

  p {
    user-select: none;
    font-size: 11px;
    line-height: 14px;
    white-space: nowrap;
    color: var(--color-alba-grandeza);
  }

  :hover {
    border-color: var(--color-blue-opacity-50);
    cursor: pointer;

    p {
      color: var(--color-navy-blue);
    }
  }

  ${(p) =>
    p.seleted &&
    css`
      border-color: var(--color-blue);

      p {
        color: var(--color-navy-blue);
      }
    `}

  ${(p) =>
    p.disabled &&
    css`
      border-color: var(--color-red) !important;
      border-color: var(--color-back-opacity-10) !important;

      p {
        color: var(--color-back-opacity-10) !important;
      }
    `}
`;
